import { render, staticRenderFns } from "./ReviewsIndicators.vue?vue&type=template&id=c13672aa&scoped=true&"
import script from "./ReviewsIndicators.vue?vue&type=script&lang=js&"
export * from "./ReviewsIndicators.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsIndicators.vue?vue&type=style&index=0&id=c13672aa&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13672aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSparkline } from 'vuetify/lib/components/VSparkline';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VContainer,VRow,VSheet,VSparkline})
